const API_BASE = 'https://api.kromaic.store/api';
// const API_BASE = 'http://localhost:5000/api';

// src/api/blog.api.js

// import axios from 'axios';
//
// // Create axios instance with base configuration
// const blogApi = axios.create({
//     baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
//     headers: {
//         'Content-Type': 'application/json',
//     },
// });
export const getAuthHeaders = () => {
    const token = localStorage.getItem('kromaic_access_token') ||
        sessionStorage.getItem('kromaic_access_token');

    const headers = {
        'Content-Type': 'application/json'
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
};

export default API_BASE